import { Card, ListLayout } from '@ingrid/luterkort-react';

import { EntityReference } from '~src/components/EntityReference/EntityReference';
import { useTranslation } from '~src/i18n/use-translation';
import { useSiteId } from '~src/main/hooks/useSiteId';
import { AppRoute } from '~src/main/routes';

import { ShipmentDetails } from '../types';
import { DirectionType } from './direction-type';

export interface ReferencesProps {
  shipment: ShipmentDetails;
}

export function References({ shipment }: ReferencesProps) {
  const siteId = useSiteId();
  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.references')}</Card.Header>
      <Card.Content>
        <ListLayout.Column>
          <EntityReference label={t('common.shipmentId')} value={shipment.id} />

          {shipment.direction_type && (
            <ListLayout.Row>
              <ListLayout.Stack>
                <ListLayout.SecondaryText>{t('common.direction')}</ListLayout.SecondaryText>
                <DirectionType direction={shipment.direction_type} />
              </ListLayout.Stack>
            </ListLayout.Row>
          )}

          <EntityReference
            href={`/${AppRoute.SITE}/${siteId}/orders/${shipment.tos.id}`}
            label={t('common.orderId')}
            value={shipment.tos.id}
          />

          {shipment.external_id && <EntityReference label={t('common.orderNumber')} value={shipment.external_id} />}
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
